import { createContext } from "react";

export const TaskContext = createContext({
  taskData: null,
  taskDataInitState: null,
  getActionData: () => {},
});
